<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'financial-finDetail-amzExpense',
  components: { PageTable },
}
</script>
